import { render, staticRenderFns } from "./AgentInfomation.vue?vue&type=template&id=20a43b8e&scoped=true&"
import script from "./AgentInfomation.vue?vue&type=script&lang=js&"
export * from "./AgentInfomation.vue?vue&type=script&lang=js&"
import style0 from "./AgentInfomation.vue?vue&type=style&index=0&id=20a43b8e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a43b8e",
  null
  
)

export default component.exports